<template>
  <generic-modal
    size
    :title="$t('movement detail')"
    icon="receipt"
    image="/images/icons/receipt.png"
    :show_cancel="false"
    :footer_buttons="footer_buttons"
    :on_finished="finished"
    @destroy="destroy"
  >
    <div class="description">
      <div class="ui small horizontal statistic">
        <div class="value">
          {{ movement.amount | formatCurrency(enterprise_setup.currency_iso) }}
        </div>
        <div
          class="label"
          v-if="movement && movement.col_account_movement_type"
        >
          {{ movement.col_account_movement_type.name }}
        </div>
      </div>
      <div class="ui green small horizontal statistic">
        <div class="value">
          {{ movement.paid | formatCurrency(enterprise_setup.currency_iso) }}
        </div>
        <div class="label">{{ $t("paid") }}</div>
      </div>
      <div class="extra">
        {{ $t("registered at") }}
        {{
          movement.create_date
            | formatDate(enterprise_setup.detailed_date_format)
        }}
      </div>
      <div class="extra" v-if="movement.expire_date">
        {{ $t("expire") }}
        {{
          movement.expire_date | formatDate(enterprise_setup.simple_date_format)
        }}
      </div>
      <div
        class="ui basic segment"
        v-if="
          movement.acc_transaction_distributions &&
          movement.acc_transaction_distributions.length
        "
      >
        <h4 class="ui dividing header">{{ $t("transaction list") }}</h4>
        <div class="ui relaxed divided list">
          <div
            class="item"
            v-for="(tx, idx) in movement.acc_transaction_distributions"
            :key="idx"
          >
            <i class="large github middle aligned icon"></i>
            <div class="content">
              <div class="header">
                {{ tx.acc_transaction.acc_transaction_type.name }}
                ({{
                  tx.acc_transaction.amount
                    | formatCurrency(enterprise_setup.currency_iso)
                }})
              </div>
              <div class="right floated">
                {{ tx.amount | formatCurrency(enterprise_setup.currency_iso) }}
              </div>
              <div class="description">
                {{
                  tx.acc_transaction.create_date
                    | formatDate(enterprise_setup.detailed_date_format)
                }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </generic-modal>
</template>

<script>
import { local_api, stringify, enterprise_setup } from "@/utils";
import GenericModal from "@/components/GenericModal";
import filters from "@/filters";

export default {
  name: "MovementDetailModal",
  filters: filters,
  components: {
    "generic-modal": GenericModal,
  },
  props: {
    movement_in: Object,
  },
  computed: {
    enterprise_setup() {
      return enterprise_setup(this);
    },
  },
  data() {
    return {
      movement: {},
      footer_buttons: [
        {
          text: this.$t("delete"),
          color: "red",
          icon: "trash",
          click: this.remove,
          visibility_condition: this.movement && this.movement.uuid,
        },
      ],
    };
  },
  methods: {
    finished() {
      // let vm = this;
      return new Promise((resolve) => {
        // vm.destroy();
        resolve();
      });
    },
    destroy() {
      this.$emit("destroy");
      this.$destroy();
    },
    remove() {
      let vm = this;
      vm.$alertify.confirm(
        vm.$t("are you sure to remove movement?"),
        function () {
          local_api(vm, "post", "/collegiate_account_movement/do-remove", {
            u: vm.movement_in.uuid,
          })
            .then(() => {
              vm.$emit("removed");
              vm.destroy();
            })
            .catch((err) => {
              vm.$alertify.error(stringify(err));
            });
        }
      );
    },
  },
  created() {
    let vm = this;
    if (vm.movement_in) {
      local_api(vm, "post", "/collegiate_account_movement/do-get", {
        u: vm.movement_in.uuid,
      })
        .then((movement) => {
          vm.movement = movement;
        })
        .catch((err) => {
          vm.$alertify.error(stringify(err));
        });
    }
  },
  mounted() {},
  watch: {},
};
</script>
